import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Api from "@/services/api"
    import { Car } from "@/services/types"
    import { ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateCar',
  props: {
    travel_company_id: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

    const props = __props
    const emit = __emit

    const car = reactive<Car>({
        name: '',
        plate: '',
        reference: '',
        travel_company_id: props.travel_company_id,
        places: 0
    })

    const rules = reactive<FormRules<Car>>({
        name: [{required: true, message: 'Preencha os campos', min: 1}],
        plate: [{required: true, message: 'Preencha os campos', min: 1}],
        reference: [{required: true, message: 'Preencha os campos', min: 1}],
    })

    // const image = ref()
    // const uri = ref<string>()
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const res = await Api.post(`admin/cars/${props.travel_company_id}`, car)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Carro cadastrado com sucesso'})
                    emit('close')
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "formRef",
    ref: formRef,
    disabled: saving.value,
    rules: rules,
    model: car,
    "label-position": "top"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        prop: "name",
        label: "Identificador do carro"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            name: "name",
            modelValue: car.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((car.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        prop: "reference",
        label: "Referência"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            name: "reference",
            modelValue: car.reference,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((car.reference) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        prop: "plate",
        label: "Placa"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            name: "plate",
            modelValue: car.plate,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((car.plate) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        prop: "places",
        label: "Quantidade de cadeira"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input_number, {
            step: 1,
            min: 1,
            name: "price",
            modelValue: car.places,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((car.places) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        plain: "",
        loading: saving.value,
        size: "large",
        type: "primary",
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode(" Cadastrar carro ", -1)
        ]))]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["disabled", "rules", "model"]))
}
}

})